import { IconCheck, IconCircleDashed } from "@tabler/icons-react";
import { Badge, Group, Text, ThemeIcon } from "@/components/ui";
import type { ProveedoresPorRfc } from "@/features/proveedor/types";

/**
 * Cabecera de la sección RFC · presentacional, sin estado.
 * Pinta el ícono de estado (asignado / pendiente), el RFC en monospace,
 * el nombre emisor con conteo de CFDIs y el badge de estado.
 */
export function SeccionRFCHeader({ grupo }: { grupo: ProveedoresPorRfc }) {
  const yaAsignado = grupo.proveedorSeleccionado !== null;
  return (
    <Group justify="space-between" align="flex-start" wrap="nowrap">
      <Group gap="sm" align="flex-start" wrap="nowrap">
        <ThemeIcon size="lg" variant="light" color={yaAsignado ? "multiva" : "slate"}>
          {yaAsignado ? <IconCheck size={20} stroke={1.8} /> : <IconCircleDashed size={20} stroke={1.6} />}
        </ThemeIcon>
        <div>
          <Group gap={6} align="baseline">
            <Text fw={600}>RFC</Text>
            <code className="rounded bg-muted px-1.5 py-0.5 font-mono text-[11px]">{grupo.rfcEmisor}</code>
          </Group>
          <Text size="sm" c="dimmed" className="mt-0.5">
            {grupo.nombreEmisor} · {grupo.cantidadCfdis} CFDI(s) · total ${grupo.totalCfdis.toFixed(2)}
          </Text>
        </div>
      </Group>
      <Badge variant="light" color={yaAsignado ? "multiva" : "slate"}>
        {yaAsignado ? "Asignado" : "Pendiente"}
      </Badge>
    </Group>
  );
}
